<template>
  <el-dialog
      :title="'发布考试'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <div>

      <el-tree
          :data="orgList"
          show-checkbox
          node-key="org_id"
          ref="tree"
          default-expand-all
          :default-checked-keys="checkList"
          @check-change="handleCheckChange"
          :props="defaultProps"
      >
      </el-tree>

      <div class="flex align-center justify-around padding-lr">
        <el-button class="padding-lr-xl" @click="resetForm">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm">发布</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {getExamOrgs,releaseExam} from "@/api/projectOffice";

export default {
  name: "releaseDialog",
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  data() {
    return {
      orgList: [],
      checkList: [],
      defaultProps: {
        children: "children",
        label: "org_name"
      },
    }
  },
  created() {
  },
  methods: {
    async getList() {
      let _data = await getExamOrgs(this.setId)
      this.orgList = [
        {
          org_name: '认证培训机构',
          children: _data.data.peixun
        },
        {
          org_name: '产教融合基地',
          children: _data.data.chanjiao
        },
      ]
    },
    resetForm() {
      this.$emit('cancelDialog', false)
    },
    submitForm() {
      if(this.checkList.length>0){
        this.poseExam()
      }else{
        this.$message.error('请选择接收考试的机构')
      }

    },
    async poseExam(){
      let _state = await releaseExam(this.setId,this.checkList.join(','))
      this.$message.success(_state.msg)
      this.$emit('cancelDialog', false)
    },
    handleCheckChange() {
      let _arr = this.$refs.tree.getCheckedKeys();
      this.checkList = _arr.filter((num) => {
        return num !== undefined;
      })
    },
  },
  watch: {
    setItem() {
      this.accountForm = {
        name: this.setItem.name
      };
    },
    setId() {
      if (this.setId) this.getList()
    }
  }
}
</script>

<style scoped lang="scss">

</style>